import {
  Dialog,
  DialogTitle,
  DialogBody,
  DialogActions,
} from "V2.0/common/dialog";
import { Button } from "V2.0/common/button";

function ExtractionParameterDelete(props) {
  const { extractionParameter, onDelete, onClose } = props;

  function handleDelete() {
    onDelete();
    onClose();
  }

  return (
    <Dialog open={true} onClose={() => {}}>
      <DialogTitle>Delete "{extractionParameter.parameterName}"?</DialogTitle>
      <DialogBody></DialogBody>
      <DialogActions>
        <Button outline onClick={onClose}>Cancel</Button>
        <Button onClick={handleDelete}>Delete</Button>
      </DialogActions>
    </Dialog>
  );
}

export default ExtractionParameterDelete;
